import { getEditor, getTemplate } from './templates';
import {
    change,
    dataBound,
    edit,
    editingKeydown,
    updateFooter,
} from './resource-entry-grid-events';
import { attachDocumentCloseHandler } from './resource-entry-editing';

export const _grid = function() {
    const me = this;
    const { readonly, staticColumns, grid: gridConfig } = me.options;
    if (me.grid) return;
    const columns = me._getColumns();
    me.gridElement = $(me.element).find(`[data-grid-for="${me._id}"]`);
    const grid = me.gridElement.kendoGrid($.extend({
        autoBind: false,
        dataSource: me.dataSource,
        columns,
        scrollable: true,
        pageable: false,
        sortable: {
            mode: 'multiple',
        },
        selectable: 'multiple, cell',
        allowCopy: true,
        editable: 'inline',
        navigatable: true,
        dataBound: dataBound.bind(me),
        change: change.bind(me),
        edit: edit.bind(me),
        beforeEdit: function(e) {
            if (e.model && e.model.ProjectedHours === 0) {
                e.preventDefault();
            }
        },
    }, gridConfig)).data('kendoGrid');
    grid.dataSource.bind('change', updateFooter.bind(me));
    // One keydown handler for Tab, Enter and Escape, passed the widget as event data
    // because binding the function call eats the event. This replaced two keydown handlers
    // and a keyup handler that each rewrote the row from a different point in the keystroke.
    grid.element.on('keydown.resourceEntryEditing', me, editingKeydown);
    // Page-wide, and only bound once however many grids ask for it. Binding a document
    // handler per widget meant every press on Schedule 5 ran the close path 18 times.
    attachDocumentCloseHandler();
    grid.readonly = readonly;
    grid.staticColumnCount = staticColumns.length;
    grid.firstEditableIndex = grid.columns.findIndex((c) => c.editable === undefined);
    return grid;
};

export const _getColumns = function() {
    const me = this;
    const { period, columnWidth, input, staticColumns } = me.options;
    const { type: inputType, typeColumn: inputTypeColumn } = input;
    const hasDetailInit = !!(me.options.grid && me.options.grid.detailInit);
    const noLockedColumns = !!me.options.noLockedColumns;
    const columns = staticColumns.slice() ?? [];
    $.each(columns, (i, column) => {
        if (!hasDetailInit && !noLockedColumns) column.locked = true;
        if (!column.template) column.template = getTemplate(column.type, inputTypeColumn)(column.field);
        if (column.editable || column.editor) {
            column.editor = column.editor || getEditor(column.type);
            delete column.editable;
        }
    });
    const columnTemplate = getTemplate(inputType, inputTypeColumn);
    const columnEditor = getEditor(inputType);
    if (period === 'month') {
        $.each(me.fieldInfo, (i, fi) => {
            const column = {
                field: fi.field,
                title: fi.title,
                hidden: false,
                locked: false,
                sortable: false,
                width: columnWidth,
                template: columnTemplate(fi.field),
                editor: columnEditor,
            };
            if (inputType !== 'columnBased') column.footerTemplate = columnTemplate('sum');
            columns.push(column);
        });
    }
    return columns;
};
